import React, { useCallback } from 'react'

import { useModal } from '../../Layout/Modal'

interface ConfirmationModalProps {
  onConfirm: () => void
  onCancel: () => void
}

type ConfirmationModalOptions = {
  title?: string
  wait?: boolean
}

const useConfirmationModal = (
  ConfirmationModal: React.FunctionComponent<ConfirmationModalProps>,
  options?: ConfirmationModalOptions
) => {
  const { openModal, closeModal } = useModal()

  return useCallback(() => {
    const confirmation = new Promise((resolve) => {
      openModal({
        label: options?.title,
        body: (
          <ConfirmationModal
            onConfirm={() => resolve(true)}
            onCancel={() => resolve(false)}
          />
        ),
        onClose: () => resolve(false),
        isAlert: true,
      })
    }).finally(async () => {
      if (!options?.wait) {
        closeModal()
      }
    })

    const waitingConfirmation = confirmation as Promise<boolean> & {
      done: () => void
    }
    waitingConfirmation.done = closeModal
    return waitingConfirmation
  }, [ConfirmationModal, closeModal, openModal, options?.title, options?.wait])
}

export { useConfirmationModal }
